/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IsolationSummaryRequest,
    IsolationSummaryRequestFromJSON,
    IsolationSummaryRequestFromJSONTyped,
    IsolationSummaryRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface EmailRequest
 */
export interface EmailRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailRequest
     */
    recipients: Array<string>;
    /**
     * 
     * @type {IsolationSummaryRequest}
     * @memberof EmailRequest
     */
    summaryRequest: IsolationSummaryRequest;
}

export function EmailRequestFromJSON(json: any): EmailRequest {
    return EmailRequestFromJSONTyped(json, false);
}

export function EmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipients': json['recipients'],
        'summaryRequest': IsolationSummaryRequestFromJSON(json['summary_request']),
    };
}

export function EmailRequestToJSON(value?: EmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipients': value.recipients,
        'summary_request': IsolationSummaryRequestToJSON(value.summaryRequest),
    };
}


